import { fetcher } from '@commenda/utils';

export async function exportSourceRecords(
  corporationId: number,
  selectedIds?: string[]
): Promise<{
  success: boolean;
  error: Error | undefined;
}> {
  try {
    const response = await fetcher(
      `new-sales-tax/source-record/export/${corporationId}`,
      {
        method: 'POST',
        body: {
          ...(selectedIds?.length ? { selectedIds } : {}),
        },
      }
    );

    const responseData = await response.json();

    if (!response.ok) {
      return {
        success: false,
        error: responseData.message || 'Failed to export records.',
      };
    }

    return {
      success: true,

      error: undefined,
    };
  } catch (error) {
    return {
      success: false,
      error: new Error(
        error instanceof Error ? error.message : 'An unexpected error occurred'
      ),
    };
  }
}
